<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click.stop="onClick">
    <img src="~@/assets/img/CITEditor/notranslate.png" alt="notranslate" title="notranslate" />
  </button>
</template>

<script>
export default {
  name: 'Notranslate',
  props: [
    'active',
    'tag'
  ],
  methods: {
    onClick () {
      document.execCommand('subscript', false)
      setTimeout(() => {
        const active = this.checkTag()
        this.$emit('setActive', { name: 'Notranslate', active: active })
      })
    },
    checkTag () {
      const selection = window.getSelection()
      const nodeName = selection.focusNode.parentNode.nodeName.toLowerCase()
      const isActive = this.tag.includes(nodeName)
      return isActive
    }
  }
}
</script>
